import {
 contactsDataPage,
} from "./contactsActions";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ErrorResponse } from "src/types/error-response.type";
import { ContactWithID, ContactsResponseLength } from "src/types/request.type";
import { SuccessResponse } from "src/types/success-response.type";




type ContactsState = {
  dataContactsPage: {
    payload: ContactsResponseLength | null;
    payload_update: ContactWithID | null;
    loading: boolean;
    success: boolean;
    error: string | null;
  };
};

const initialState: ContactsState = {
  dataContactsPage: {
    loading: false,
    success: false,
    payload_update: null,
    payload: null,
    error: "",
  },
};

const contactsSlicePage = createSlice({
  name: "contactsPage",
  initialState: initialState,
  reducers: {
    // Обычные редьюсеры
    setContactsStatePage(state, action: PayloadAction<ContactsResponseLength>) {
      const stateNew = state;
      stateNew.dataContactsPage.payload =  {} as ContactsResponseLength; //[];
      stateNew.dataContactsPage.payload = action.payload;
      state = stateNew;
    },

    setContactsUpdateStatePage(state, action: PayloadAction<ContactWithID>) {
      state.dataContactsPage.payload_update = null;
      state.dataContactsPage.payload_update = action.payload;

    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(contactsDataPage.pending, (state) => {
        state.dataContactsPage.loading = true;
        state.dataContactsPage.error = null;
      })
      .addCase(contactsDataPage.fulfilled, (state, action) => {
        state.dataContactsPage.loading = false;
        contactsSlicePage.caseReducers.setContactsStatePage(state, action);
      })
      .addCase(contactsDataPage.rejected, (state, action) => {
        state.dataContactsPage.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataContactsPage.error = errorText ? errorText : "";
      })

      },
});

const getErrorText = (error: ErrorResponse) => {
 // console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
};

export default contactsSlicePage.reducer;

